import { type Control, Controller } from 'react-hook-form';
import { z } from 'zod';

import { Checkbox } from '@/components/controls';
import {
  CheckboxGroup,
  type CheckboxGroupProps,
} from '@/components/controls/checkbox/CheckboxGroup';

export type FormCheckboxGroupProps = CheckboxGroupProps & {
  control?: Control;
  name: string;
  children: React.ReactNode[];
  label?: string;
  description?: string;
  error?: string;
};

export const FormCheckboxGroup = ({
  name,
  control,
  children,
  ...props
}: FormCheckboxGroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <CheckboxGroup {...props} onChange={onChange} value={value}>
            {children}
          </CheckboxGroup>
        );
      }}
    />
  );
};

FormCheckboxGroup.displayName = 'Form.CheckboxGroup';

export const required = (message = 'Select one option') => {
  return z.array(z.string()).min(1, message);
};

FormCheckboxGroup.rules = { required };

FormCheckboxGroup.Checkbox = Checkbox;
